export { default as PostCard } from "./PostCard";
